import DatatableOrders from "../../components/datatableOrders/DatatableOrders";
import { Navbar } from "../../components/navbar/Navbar";
import { Sidebar } from "../../components/sidebar/Sidebar";
import "./List.css";

const ListOrders = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <DatatableOrders />
      </div>
    </div>
  );
};

export default ListOrders;

